import { HistoryOrder, IHistoryOrderData, historyOrderFactory } from '@df/session/api/history/history-order';

export namespace NTradeHistory {
    export interface ITradeHistoryOrderData {
        '@odata.etag': string;
        Document_Type: string;
        No: string;
        Sell_to_Customer_No: string;
        Order_Date: string;
        Sell_to_Customer_Name: string;
        Sell_to_Address: string;
        Sell_to_Country_Region_Code: string;
        Document_Date: string;
        Requested_Delivery_Date: string;
        Promised_Delivery_Date: string;
        items?: ITradeHistoryOrderItem[];
    }

    export interface ITradeHistoryOrderItem {
        '@odata.etag': string;
        Document_Type: string;
        Document_No: string;
        Line_No: number;
        LM_Phase: string;
        Sell_to_Customer_No: string;
        Magento_Entity_ID: number;
        Magento_Order_No: string;
        Magento_Order_Line_No: number;
        Posting_Date: string;
        No: string;
        Description: string;
        Quantity: number;
        Outstanding_Quantity: number;
        Unit_Price: number;
        EstimatedDate: string;
    }
}

export enum EOrderStatuses {
    refunded = 'Refunded',
    dispatched = 'Dispatched',
    partial = 'Partially dispatched',
    ordered = 'Ordered'
}

export class LocalHistoryOrder extends HistoryOrder {
    private _orderStatus!: EOrderStatuses;
    private _formattedNumber!: string;

    get orderStatus(): string {
        return this._orderStatus;
    }

    get formattedNumber(): string {
        return this._formattedNumber;
    }

    protected override setData(data: IHistoryOrderData) {
        super.setData(data);

        this._formattedNumber = this.data.number?.match(/.{1,3}/g)?.join(' ') || '';

        const items = this.data.items;
        if (!items.find(item => item.qty_refunded !== item.qty_ordered)) {
            // Refunded - only if ALL items ordered were refunded
            this._orderStatus = EOrderStatuses.refunded;
        } else if (!items.find(item => item.qty_shipped !== item.qty_ordered || item.qty_refunded || item.qty_canceled)) {
            // Dispatched - if all non-cancelled and non-refunded items were shipped
            this._orderStatus = EOrderStatuses.dispatched;
        } else if (items.find(item => !!item.qty_shipped && !item.qty_refunded && !item.qty_canceled)) {
            // if not all shipped make sure that one is shipped
            // Partially dispatched - if there is at least 1 shipped item but also at least one unshipped, non-refuneded one
            this._orderStatus = EOrderStatuses.partial;
        } else {
            // Ordered - if there is none shipped and not all refunded (technically if you had 2 lines and 1 refunded, status is still ordered)
            this._orderStatus = EOrderStatuses.ordered;
        }
    }
}

historyOrderFactory.instance = LocalHistoryOrder;
